<div class="modal-background" bdFxLayoutAlign="center start">
    <div class="projects-modal">
        <div bdFxLayoutAlign="space-between center" class="header">
            <div bdFxFlex bdFxLayoutAlign="start center" class="cancel">
                <button (click)="onCancelBtnClicked()" type="button">Abbrechen</button>
            </div>
            <div bdFxFlex="1 1 auto" bdFxLayoutAlign="center center" class="title">{{getTitle()}}</div>
            <div bdFxFlex bdFxLayoutAlign="end center" class="save">
                <button class="bd-blue-button" (click)="onSubmitBtnClicked()" type="button">Hinzufügen</button>
            </div>
        </div>
        <form class="body">
            <div class="table">


                <div class="filter-search-text-input">
                    <span class="placeholder" *ngIf="!searchPhrase">
                        <bd-fa [name]="'search'"></bd-fa>
                        <span>Suchen...</span>
                    </span>
                    <bd-labeled-input [(ngModel)]="searchPhrase"
                                      (ngModelChange)="announceSearchTermChanged($event)"
                                      [name]="'search'">
                    </bd-labeled-input>

                </div>

                <div class="table-body">

                    <ng-container *ngFor="let itemContainer of filteredAccessoryContainers">
                        <div class="table-row sub-item without-device">
                            <div class="column-article-cell">
                                <app-product-label [orderItemContainer]="itemContainer"></app-product-label>
                            </div>

                            <div class="button-cell">
                                <bd-checkbox-rounded [name]="itemContainer.id"
                                                     [(ngModel)]="itemContainer.containerSharedMetadata.addToProductOrderList"
                                                     (ngModelChange)="onSubItemCheckboxClicked( itemContainer )">
                                </bd-checkbox-rounded>
                            </div>
                        </div>
                    </ng-container>

                </div>

            </div>
        </form>
    </div>
</div>


